<template>
  <div class="catalog-view" id="catalog-view-container">
    <div class="product-table-loading" v-if="!isLoaded">
      <div class="product-table-loading-container">
        <img src="/img/ic_loading.svg">
      </div>
    </div>
    <div class="container" v-if="isError">
      <div class="catalog-view__error">
        <h1>Страница не найдена</h1>
        <p>Данные по продукту <strong>{{ id }}</strong> не найдены</p>
      </div>
    </div>
    <div class="container" v-if="isLoaded && !isError">

      <product ref="product" :product="product"/>

      <ul class="catalog-view__chips" v-if="chips.length > 1">
        <li v-for="(chip, key) in chips" :key="key">
          <a :href="'#' + chip.link">{{ chip.title }} <span v-if="chip.size"> {{ chip.size }}</span></a>
        </li>
      </ul>

      <product-hierarchy :product_id="product.id" @addChip="addChip"/>

      <related :product_id="product.id" :type="COMPATIBLE" @addChip="addChip"/>

      <related :product_id="product.id" :type="CROSS_SELLING" @addChip="addChip"/>

      <etim :product="product" @addChip="addChip"/>

      <div class="catalog-view__box">
        <certificate :product_id="product.id" @addChip="addChip"/>
      </div>

      <media :product_id="product.id" @addChip="addChip"/>

      <div id="analogs">
        <common-analog :product_id="product.id" @addChip="addChip"/>
        <kit-analog :product_id="product.id" @addChip="addChip"/>
      </div>

      <tnvd :product="product" />

      <packing-gross :product_id="product.id" @addChip="addChip"/>

      <div class="catalog-view__foot">
        <div class="catalog-view__items">
          <packing-netto :product_id="product.id" @addChip="addChip"/>
          <characteristic :product_id="product.id" @addChip="addChip"/>
        </div>
        <div class="catalog-view__banner">
          <div class="catalog-view__banner-title">Интеграция с каталогом</div>
          <div class="catalog-view__banner-text">Вы можете обновлять данные со своим интернет-магазином или электронным
            каталогом в автоматическом режиме по API.
          </div>
          <a class="catalog-view__link catalog-view__link--lg" href="/documentation-api">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86"/>
              <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2"/>
            </svg>
            <span>Документация API</span>
          </a>
        </div>
      </div>

      <product-modal :product_id="product.id"/>
    </div>
  </div>
</template>

<script>

import Product from "@/components/product-card/Product";
import ProductHierarchy from "../components/product-card/ProductHierarchy";
import Certificate from "../components/product-card/Certficate";
import Characteristic from "../components/product-card/Characteristic";
import PackingNetto from "../components/product-card/PackingNetto";
import PackingGross from "../components/product-card/PackingGross";
import Media from "../components/product-card/Media";
import Etim from "../components/product-card/Etim";
import Related from "../components/product-card/Related";
import CommonAnalog from "../components/product-card/CommonAnalog";
import KitAnalog from "../components/product-card/KitAnalog";
import Tnvd from "../components/product-card/Tnvd";
import {COMPATIBLE, CROSS_SELLING} from '../common/relatedType';
import {IMAGES, PDF} from '../common/fileType';
import ProductModal from "../components/product-card/ProductModal";

export const EVENT_ADD_CHIPS = 'addChip'

export default {
  name: 'product-card',
  components: {
    ProductModal,
    Related,
    Etim,
    Media,
    PackingGross,
    PackingNetto,
    Characteristic,
    Certificate,
    ProductHierarchy,
    Product,
    CommonAnalog,
    KitAnalog,
    Tnvd
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isError: false,
    isLoaded: false,
    product: null,
    COMPATIBLE,
    CROSS_SELLING,
    chips: []
  }),
  mounted() {
    this.$root.$on('create-pdf::fire', this.createPdf)
    this.$root.$on('create-image-file::fire', this.createImage)
  },
  created() {
    this.$api.product.get(this.id, 'photos360,images,activity,etimClass,keywords,lines,replacementReferences,rates,tnvdCode').then((response) => {
      if (response && response.data) {
        this.product = response.data
      }
      this.isLoaded = true
    }).catch(() => {
      this.isLoaded = true
      this.isError = true
    })
  },
  methods: {
    addChip(data) {
      if (Array.isArray(data)) {
        data.forEach(item => this.chips.push(item))
      } else {
        this.chips.push(data)
      }

      this.chips.sort((a, b) => a.order - b.order)
    },
    createPdf() {
      this.createFile(PDF)
    },
    createImage() {
      this.createFile(IMAGES)
    },
    createFile(type) {
      let filename = ''
      switch (type) {
        case PDF:
          filename = this.product.reference + '.pdf'
          break
        case IMAGES:
          filename = this.product.reference + '_fotos.zip'
          break
      }
      this.$api.product.createFile(this.product.id, type).then((response) => {
        if (response && response.data) {
          this.fileId = response.data.id
          let object = this
          const timer = setInterval(async function () {
            const data = await object.$api.product.file(object.fileId)
            const file = data.data
            if (file.status < 2) {
              return
            }
            if (file.status === 2) {
              clearInterval(timer)
              object.$api.product.downloadFile(file.id).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', filename)
                    link.click()
                  }
              ).catch(() => {
              })
              switch (type) {
                case PDF:
                  object.$refs.product.pdfFinished()
                  break
                case IMAGES:
                  object.$refs.product.imageFinished()
                  break
              }
              return
            }
            clearInterval(timer)
          }, 2000)
        }
      }).catch(() => {

      })
    }
  }
}
</script>